module.exports = __webpack_public_path__ + "img/oYes.fff020ef.png";